import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { RESEARCH_DISCLAIMER } from '../mock/mock';

export default function DisclaimerBox({ compact = false }) {
  return (
    <div className="hairline rounded bg-alp-card/60 px-5 py-4 flex gap-3 items-start">
      <ShieldCheck size={18} strokeWidth={1.5} className="text-alp-gold mt-0.5 shrink-0" />
      <p className={`text-alp-gray leading-relaxed ${compact ? 'text-xs' : 'text-sm'}`}>
        {RESEARCH_DISCLAIMER}
      </p>
    </div>
  );
}
